<template>
<div class="contact-side">
    <div class="contact-side__img">
        <div  class="decoration decoration--before"></div>
        <NuxtImg src="/photo-contact.png" alt="" lazy="loading" format="webp" />
        <div  class="decoration decoration--after"></div>
    </div>
    <div class="contact-side__content" v-if="content">
        <h2>{{ content.titre }}</h2>
       <div v-html="content.contenu"></div>
    </div>
    <div class="contact-side__btns">
        <ElementCustomButton label="Envoyer un mail" to="mailto:paulinefuchs@hotmail.fr" />
        <ElementCustomButton label="Prendre un rendez-vous" target="_blank" to="https://tidycal.com/paulinefuchs/30-minute-meeting"/>
    </div>
</div>
</template>

<script setup lang="ts">
import type { Contact } from '~/types/options';
import ElementCustomButton from '@/components/elements/CustomButton.vue'

defineProps<{
    content:Contact
}>()
</script>

<style lang="scss">
    .contact-side{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
        @media screen and (max-width:1250px) {
            justify-content: space-between;   
        }
        @media screen and (max-width:1035px) {
            margin-bottom: 50px;
        }
        @media screen and (max-width:600px) {
           flex-direction: column;
        }
       &__img{
        position: relative;
        .decoration{
            position: absolute; 
            background-repeat: no-repeat;
            background-size: contain;
            &--before{
                background-image: url('~/assets/svgs/etoile1.svg');
                width: 50px;
                height: 50px;
                top: 20px;
                left: 20px;
            }
            &--after{
                background-image: url('~/assets/svgs/duo-etoiles.svg');
                width: 100px;
                height: 105px;
                right: 20px;
                bottom: 0;
            }
        }
         img{
            width: 280px;
        }
       }
        &__content{
            width: calc(100% - 330px);
            padding-left:50px;
            @media screen and (max-width:1035px){
                padding-left:0;
            }
            @media screen and (max-width:600px) {
                margin-top: 20px;
                
                width: 100%;
                text-align: center;
            }
            h2{
                text-align: left;
                 margin-bottom: 20px;
                 @media screen and (max-width:1035px) {
                    text-align: left;
                 }
                 @media screen and (max-width:600px) {
                    text-align: center;
                    margin-bottom: 0;
                }
            }
            p{
                font-weight: 600;
                font-size: 18px;
                @media screen and (max-width:1035px) {
                    padding-left: 0;
                }
            }
        }&__btns{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 30px;
            gap: 20px;
            @media screen and (max-width:600px) {
           flex-direction: column;
           align-items: center;
        }
        }
    }
</style>